/**
 * @flow
 * @relayHash db245e303a14ddfe391344f70c9e56da
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GenerateEventCertificateInput = {|
  eventId: string,
  media: string,
  startnumber: string,
|};
export type GenerateEventCertificateMutationVariables = {|
  input: GenerateEventCertificateInput
|};
export type GenerateEventCertificateMutationResponse = {|
  +generateEventCertificate: ?{|
    +url: ?string
  |}
|};
export type GenerateEventCertificateMutation = {|
  variables: GenerateEventCertificateMutationVariables,
  response: GenerateEventCertificateMutationResponse,
|};
*/


/*
mutation GenerateEventCertificateMutation(
  $input: GenerateEventCertificateInput!
) {
  generateEventCertificate(input: $input) {
    url
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "GenerateEventCertificateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generateEventCertificate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateEventCertificatePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GenerateEventCertificateMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GenerateEventCertificateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GenerateEventCertificateMutation",
    "id": null,
    "text": "mutation GenerateEventCertificateMutation(\n  $input: GenerateEventCertificateInput!\n) {\n  generateEventCertificate(input: $input) {\n    url\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ec99e1219ffec4532ebc39bf4c987bcf';

module.exports = node;
